module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LQ070Y3LG05-1-20-15.699dc159.pdf";